import { fetch } from '@atlassian/eoc-fetch';
export const getRoleBasedNotificationsEndpoint = () => fetch(`/v1/role-based-notifications`);
export const getRoleBasedNotificationDetailEndpoint = settingId => fetch(`/v1/role-based-notifications/${settingId}`);